import React from "react";
import { FaBars, FaCog, FaSignOutAlt } from "react-icons/fa";

const Header = ({
  user,
  onLogout,
  isMobile,
  onToggleSidebar,
  onEditProfile,
}) => {
  return (
    <header className="bg-black text-white py-2 md:py-3 px-3 md:px-4 flex justify-between items-center shadow-lg border-b border-gray-800 h-16">
      <div className="flex items-center space-x-2">
        {isMobile && (
          <button
            onClick={onToggleSidebar}
            className="p-2 -ml-2 text-gray-400 hover:text-purple-400 focus:outline-none focus:ring-2 focus:ring-purple-500 rounded-lg"
            aria-label="Toggle Sidebar"
          >
            <FaBars className="h-5 w-5" />
          </button>
        )}
        <div className="flex items-center">
          <div className="h-8 w-8 md:h-9 md:w-9 rounded-full bg-gradient-to-br from-purple-600 to-purple-700 flex items-center justify-center text-base md:text-lg font-semibold shadow-inner">
            {user?.firstName?.[0] || "U"}
          </div>
          <span className="font-medium ml-2 hidden md:inline text-sm md:text-base">
            {user?.firstName || "User"} {user?.lastName || ""}
          </span>
        </div>
      </div>

      <div className="flex items-center space-x-1 md:space-x-3">
        <button
          onClick={onEditProfile}
          className="p-2 md:px-3 md:py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-sm font-medium transition-all duration-200 flex items-center focus:outline-none focus:ring-2 focus:ring-purple-500"
          title="Settings"
        >
          <span className="hidden md:inline mr-2">Settings</span>
          <FaCog className="h-4 w-4" />
        </button>
        <button
          onClick={onLogout}
          className="p-2 md:px-3 md:py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-sm font-medium transition-all duration-200 flex items-center focus:outline-none focus:ring-2 focus:ring-purple-500"
          title="Logout"
        >
          <span className="hidden md:inline mr-2">Logout</span>
          <FaSignOutAlt className="h-4 w-4" />
        </button>
      </div>
    </header>
  );
};

export default Header;
